import { css } from '@emotion/react';

export const palette = {
  primaryColor: '#D42880',
  secondaryColor: '#383838',

  /* forest-green */
  colorGreen100: '#DBFFF2',
  colorGreen200: '#95EBC9',
  colorGreen300: '#00D9A6', // primary
  colorGreen400: '#00C395',
  colorGreen500: '#009874',
  /* forest-navy */
  colorNavy100: '#DDDFF7',
  colorNavy200: '#BABCD4',
  colorNavy300: '#9B9DB4',
  colorNavy400: '#5E6075',
  colorNavy500: '#1D2032', // secondary
  /* blue */
  colorBlue100: '#D6DDFF',
  colorBlue200: '#7790FA',
  colorBlue300: '#6380F9',
  colorBlue400: '#5973E0',
  colorBlue500: '#3C55BD',
  /* yellow */
  colorYellow100: '#FFF6A0',
  colorYellow200: '#FFEF5C',
  colorYellow300: '#FED51F',
  colorYellow400: '#FFB800',
  colorYellow500: '#FF7A00',
  /* purple */
  colorPurple100: '#E9BFFA',
  colorPurple200: '#DC93F8',
  colorPurple300: '#C136F2',
  colorPurple400: '#A000E8',
  colorPurple500: '#8600E2',
  /* red */
  colorRed100: '#FFB0B0',
  colorRed200: '#FF7E7E',
  colorRed300: '#F44545',
  colorRed400: '#D31414',
  colorRed500: '#B40B0B',
  /* brown-color */
  colorBrown100: '#886952', // ivstr main
  colorBrown200: '#F0804C',
  colorBrown300: '#96AC39',
  colorBrown400: '#EAAF3D',
  colorBrown500: '#687B5F',
  /* gray-color */
  white: '#FFFFFF',
  gray1: '#FAFAFA',
  gray2: '#F2F2F2',
  gray3: '#E0E0E0',
  gray4: '#BDBDBD',
  gray5: '#888888',
  gray6: '#4F4F4F',
  black: '#222222',
  realBlack: '#000000',

  /* semantic-color */
  colorSuccess: '#00D9A6',
  colorWarning: '#FED51F',
  colorDanger: '#F44545',
  colorInfo: '#6380F9',
};
const theme = {
  primary: {
    background: palette.colorGreen300,
    color: palette.white,
    hoverColor: palette.white,
    hoverBackground: palette.colorGreen400,
    lineColor: palette.colorGreen400,
    lineBorderColor: palette.colorGreen400,
    lineHoverBackground: palette.colorGreen100,
  },
  secondary: {
    background: palette.colorNavy500,
    color: palette.white,
    hoverColor: palette.white,
    hoverBackground: palette.colorNavy400,
    lineColor: palette.colorNavy500,
    lineBorderColor: palette.colorNavy500,
    lineHoverBackground: palette.colorNavy100,
  },
  grayscale: {
    background: palette.gray2,
    color: palette.gray6,
    hoverColor: palette.gray6,
    hoverBackground: palette.gray3,
    lineColor: palette.black,
    lineBorderColor: palette.gray3,
    lineHoverBackground: palette.gray2,
  },
};

export const SEBANG_GOTHIC_FONT = css`
  font-family: SEBANG_Gothic, 'Noto Sans KR', 'Malgun Gothic', 돋움, Dotum,
    Helvetica, Arial, sans-serif;
`;

export const PRETENDARD_FONT = css`
  font-family: 'Pretendard', 'Noto Sans KR', 'Malgun Gothic', 돋움, Dotum,
    Helvetica, Arial, sans-serif;
`;

export default theme;
